module.exports = __webpack_public_path__ + "img/產品資訊_產品單圖-06.aa5f46c2.png";